import { startRegistration, startAuthentication } from '@simplewebauthn/browser';
import { api } from './api';

export async function registerWithPasskey(email: string, name: string) {
  const opts = await api.registerBegin({ email, name });
  const attResp = await startRegistration({ optionsJSON: opts });
  return await api.registerComplete(attResp);
}

export async function loginWithPasskey(email?: string) {
  const opts = await api.loginBegin({ email });
  const authResp = await startAuthentication({ optionsJSON: opts });
  return await api.loginComplete(authResp);
}

export function isPasskeySupported(): boolean {
  return typeof window !== 'undefined' && !!window.PublicKeyCredential;
}
